"use client";
import React from "react";
import { storyblokEditable } from "@storyblok/react";
import MembersGrid from "@/library/sections/grids/MembersGrid";

export default function MembersGridBlock({ blok }) {
  return (
    <div {...storyblokEditable(blok)}>
      <MembersGrid
        blok={blok}
        title={blok.title}
        titleAs={blok.titleAs}
        titleColor={blok.titleColor}
        description={blok.description}
        descriptionColor={blok.descriptionColor}
        membersGrid={blok.membersGrid}
        backgroundColor={blok.backgroundColor}
      />
    </div>
  );
}
